import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { PaymentService } from 'src/app/services/payment.service';

@Component({
    selector: 'app-add-state-wallet-balance',
    templateUrl: './add-state-wallet-balance.component.html',
    styleUrls: ['./add-state-wallet-balance.component.scss'],
    standalone: false
})
export class AddStateWalletBalanceComponent implements OnInit {

  addWalletForm: FormGroup;
  addNewWalletDetails!: FormArray;
  submitted: boolean = false;
  states: any = [];
  stamp_types = [
    { code: 'PHYSTMAP', name: "physical" },
    { code: 'ESTAMP', name: "estamp" },
    { code: 'ESBTR', name: "esbtr" },
    { code: 'ECHALLAN', name: "echallan" }
  ];
  typeData : any = [];
  selStateId: any;
  constructor(
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private paymentService: PaymentService,
    private router: Router
  ) {
    this.addWalletForm = this.formBuilder.group({
      addNewWalletDetails: this.formBuilder.array([])
    });
  }

  ngOnInit(): void {
    this.getStates()
    this.walletDetailsArray().push(this.initWalletDetails())
  }

  getStates() {
    this.paymentService.getState().subscribe((res: any) => {
      this.states = res['content'];
    })
  }

  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }

  removeDetails(index: number) {
    this.walletDetailsArray().removeAt(index);
  }

  walletDetailsArray(): FormArray {
    return this.addWalletForm.get("addNewWalletDetails") as FormArray;
  }

  addnewWalletDetail() {
    if (this.addWalletForm.controls['addNewWalletDetails'].valid) {
      this.walletDetailsArray().push(this.initWalletDetails())
    }

    else {
      this.messageService.add({ severity: 'warn', summary: 'New user', detail: 'Please fill user details before adding New' });
    }
  }

  initWalletDetails() {
    return this.formBuilder.group({
      state: new FormControl(null, [Validators.required]),
      denomination: new FormControl(null, [Validators.required]),
      stampType: new FormControl('', [Validators.required]),
      amount: new FormControl(null, [Validators.required])
    });
  }

  saveDetails() {
    this.submitted = true;
   
    if (this.addWalletForm.invalid) {
     
      return;
    }

    const addNewWalletDetailsFormArray = this.addWalletForm.get('addNewWalletDetails') as FormArray;
    const walletDetailsArray: any[] = [];

    // Iterate over each FormGroup in the FormArray
    addNewWalletDetailsFormArray.controls.forEach((abstractControl: AbstractControl) => {
      if (abstractControl instanceof FormGroup) {
        const formGroup = abstractControl as FormGroup;
        var walletDetail = {
          state_id: formGroup.controls['state'].value,
          denomination: formGroup.controls['denomination'].value,
          stamp_type: formGroup.controls['stampType'].value,
          amount: formGroup.controls['amount'].value
        };
        walletDetailsArray.push(walletDetail);
      }
    });



    this.paymentService.addNewStateWallet(walletDetailsArray).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.messageService.add({ severity: 'success', summary: res.message });
          setTimeout(() => {
            this.router.navigate(['/doqfy/wallet/amount-balance']);
          }, 500)
        }
      },
      (error: any) => {
      
        this.messageService.add({ severity: 'error', summary: error.error.message });
      }
    );
  }

  numberOnly(event: any) {
    const pattern = /[0-9\-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar) || event.keyCode == 45) {
      event.preventDefault();
    } else if (event.target.value === '0') {
      event.preventDefault();
    }
  }

  // getStampType(event: any, index) {
  //   let branchCode;
  //   this.states.forEach((state) => {
  //     if (state.id === event.value) {
  //       branchCode = state.state_code
  //     }
  //   });
  //   this.paymentService.getStampTypeByState(branchCode).subscribe(res => {
  //     const stamptype = res['content'][0];

  //     const trueKeys = [];
  //     for (const key in stamptype) {
  //       if (stamptype[key] === true) {
  //         trueKeys.push(key);
  //       }
  //     }
  //     this.typeData = this.stamp_types.filter((stamp) => trueKeys.includes(stamp.name));
  

  //   })


  // }

  getStampType(event: any, index: number) {
    this.selStateId = event.value;
    let branchCode;
    this.states.forEach((state) => {
      if (state.id === event.value) {
        branchCode = state.state_code;
      }
    });

    this.paymentService.getStampTypeByState(branchCode).subscribe(res => {
      const stamptype = res['content'][0];
      const trueKeys = [];

      for (const key in stamptype) {
        if (stamptype[key] === true) {
          trueKeys.push(key);
        }
      }

      //let typeData: { code: string; name: string; }[];
      this.typeData[index] = this.stamp_types.filter((stamp) => trueKeys.includes(stamp.name));

      // Update the typeData within the FormArray at the specified index
      // const stampArray = this.addWalletForm.get('addNewWalletDetails') as FormArray;
      // const stampGroup = stampArray.at(index) as FormGroup;
      // stampGroup.patchValue({ stampType: typeData });
    });
  }

}
